/**
 * @generated SignedSource<<1c081159e8cfc8d2ccd400b7ac3915be>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UtilizationReportPeriodRoleLoader_viewer$data = {
  readonly company: {
    readonly resourceBasedRoles: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly name: string | null;
          readonly resourceNumbers: {
            readonly actualBillableProjectMinutes: number | null;
            readonly actualNonBillableProjectMinutes: number | null;
            readonly actualInternalMinutes: number | null;
            readonly actualTotalMinutes: number | null;
            readonly actualOverMinutes: number | null;
            readonly actualDoneTaskMinutes: number | null;
            readonly actualBillableUtilization: number | null;
            readonly actualNonBillableUtilization: number | null;
            readonly actualInternalUtilization: number | null;
            readonly actualResourceUtilization: number | null;
            readonly plannedBillableProjectMinutes: number | null;
            readonly plannedBillableProjectMinutesWin: number | null;
            readonly plannedBillableProjectMinutesSoft: number | null;
            readonly plannedBillableProjectMinutesSoftWin: number | null;
            readonly plannedBillableProjectMinutesHard: number | null;
            readonly plannedNonBillableProjectMinutes: number | null;
            readonly plannedNonBillableProjectMinutesWin: number | null;
            readonly plannedNonBillableProjectMinutesSoft: number | null;
            readonly plannedNonBillableProjectMinutesSoftWin: number | null;
            readonly plannedNonBillableProjectMinutesHard: number | null;
            readonly plannedInternalMinutes: number | null;
            readonly plannedTotalMinutes: number | null;
            readonly plannedTotalMinutesWin: number | null;
            readonly plannedTotalMinutesSoft: number | null;
            readonly plannedTotalMinutesSoftWin: number | null;
            readonly plannedTotalMinutesHard: number | null;
            readonly plannedOverMinutes: number | null;
            readonly plannedOverMinutesWin: number | null;
            readonly plannedOverMinutesSoft: number | null;
            readonly plannedOverMinutesSoftWin: number | null;
            readonly plannedOverMinutesHard: number | null;
            readonly plannedDoneTaskMinutes: number | null;
            readonly plannedBillableUtilization: number | null;
            readonly plannedBillableUtilizationWin: number | null;
            readonly plannedBillableUtilizationSoft: number | null;
            readonly plannedBillableUtilizationSoftWin: number | null;
            readonly plannedBillableUtilizationHard: number | null;
            readonly plannedNonBillableUtilization: number | null;
            readonly plannedNonBillableUtilizationWin: number | null;
            readonly plannedNonBillableUtilizationSoft: number | null;
            readonly plannedNonBillableUtilizationSoftWin: number | null;
            readonly plannedNonBillableUtilizationHard: number | null;
            readonly plannedInternalUtilization: number | null;
            readonly plannedResourceUtilization: number | null;
            readonly plannedResourceUtilizationWin: number | null;
            readonly plannedResourceUtilizationSoft: number | null;
            readonly plannedResourceUtilizationSoftWin: number | null;
            readonly plannedResourceUtilizationHard: number | null;
            readonly plannedBillableTaskAndAllocationsCombined: number | null;
            readonly plannedNonBillableTaskAndAllocationsCombined: number | null;
            readonly plannedInternalTimeTaskAndAllocationsCombined: number | null;
            readonly plannedTotalTimeTaskAndAllocationsCombined: number | null;
            readonly plannedBillableUtilizationTaskAndAllocationsCombined: number | null;
            readonly plannedNonBillableUtilizationTaskAndAllocationsCombined: number | null;
            readonly plannedInternalUtilizationTaskAndAllocationsCombined: number | null;
            readonly plannedResourceUtilizationTaskAndAllocationsCombined: number | null;
            readonly plannedBillableTaskAndAllocationsCombinedWin: number | null;
            readonly plannedNonBillableTaskAndAllocationsCombinedWin: number | null;
            readonly plannedTotalTimeTaskAndAllocationsCombinedWin: number | null;
            readonly plannedBillableUtilizationTaskAndAllocationsCombinedWin: number | null;
            readonly plannedNonBillableUtilizationTaskAndAllocationsCombinedWin: number | null;
            readonly plannedResourceUtilizationTaskAndAllocationsCombinedWin: number | null;
            readonly plannedBillableTaskAndAllocationsCombinedSoft: number | null;
            readonly plannedNonBillableTaskAndAllocationsCombinedSoft: number | null;
            readonly plannedTotalTimeTaskAndAllocationsCombinedSoft: number | null;
            readonly plannedBillableUtilizationTaskAndAllocationsCombinedSoft: number | null;
            readonly plannedNonBillableUtilizationTaskAndAllocationsCombinedSoft: number | null;
            readonly plannedResourceUtilizationTaskAndAllocationsCombinedSoft: number | null;
            readonly plannedBillableTaskAndAllocationsCombinedSoftWin: number | null;
            readonly plannedNonBillableTaskAndAllocationsCombinedSoftWin: number | null;
            readonly plannedTotalTimeTaskAndAllocationsCombinedSoftWin: number | null;
            readonly plannedBillableUtilizationTaskAndAllocationsCombinedSoftWin: number | null;
            readonly plannedNonBillableUtilizationTaskAndAllocationsCombinedSoftWin: number | null;
            readonly plannedResourceUtilizationTaskAndAllocationsCombinedSoftWin: number | null;
            readonly plannedBillableTaskAndAllocationsCombinedHard: number | null;
            readonly plannedNonBillableTaskAndAllocationsCombinedHard: number | null;
            readonly plannedTotalTimeTaskAndAllocationsCombinedHard: number | null;
            readonly plannedBillableUtilizationTaskAndAllocationsCombinedHard: number | null;
            readonly plannedNonBillableUtilizationTaskAndAllocationsCombinedHard: number | null;
            readonly plannedResourceUtilizationTaskAndAllocationsCombinedHard: number | null;
            readonly remainingBillableTaskAndAllocationsCombinedWin: number | null;
            readonly remainingNonBillableTaskAndAllocationsCombinedWin: number | null;
            readonly remainingTotalTimeTaskAndAllocationsCombinedWin: number | null;
            readonly remainingBillableUtilizationTaskAndAllocationsCombinedWin: number | null;
            readonly remainingNonBillableUtilizationTaskAndAllocationsCombinedWin: number | null;
            readonly remainingResourceUtilizationTaskAndAllocationsCombinedWin: number | null;
            readonly remainingBillableTaskAndAllocationsCombinedSoft: number | null;
            readonly remainingNonBillableTaskAndAllocationsCombinedSoft: number | null;
            readonly remainingTotalTimeTaskAndAllocationsCombinedSoft: number | null;
            readonly remainingBillableUtilizationTaskAndAllocationsCombinedSoft: number | null;
            readonly remainingNonBillableUtilizationTaskAndAllocationsCombinedSoft: number | null;
            readonly remainingResourceUtilizationTaskAndAllocationsCombinedSoft: number | null;
            readonly remainingBillableTaskAndAllocationsCombinedSoftWin: number | null;
            readonly remainingNonBillableTaskAndAllocationsCombinedSoftWin: number | null;
            readonly remainingTotalTimeTaskAndAllocationsCombinedSoftWin: number | null;
            readonly remainingBillableUtilizationTaskAndAllocationsCombinedSoftWin: number | null;
            readonly remainingNonBillableUtilizationTaskAndAllocationsCombinedSoftWin: number | null;
            readonly remainingResourceUtilizationTaskAndAllocationsCombinedSoftWin: number | null;
            readonly remainingBillableTaskAndAllocationsCombinedHard: number | null;
            readonly remainingNonBillableTaskAndAllocationsCombinedHard: number | null;
            readonly remainingTotalTimeTaskAndAllocationsCombinedHard: number | null;
            readonly remainingBillableUtilizationTaskAndAllocationsCombinedHard: number | null;
            readonly remainingNonBillableUtilizationTaskAndAllocationsCombinedHard: number | null;
            readonly remainingResourceUtilizationTaskAndAllocationsCombinedHard: number | null;
            readonly forecastBillableTaskAndAllocationsCombinedWin: number | null;
            readonly forecastNonBillableTaskAndAllocationsCombinedWin: number | null;
            readonly forecastTotalTimeTaskAndAllocationsCombinedWin: number | null;
            readonly forecastBillableUtilizationTaskAndAllocationsCombinedWin: number | null;
            readonly forecastNonBillableUtilizationTaskAndAllocationsCombinedWin: number | null;
            readonly forecastResourceUtilizationTaskAndAllocationsCombinedWin: number | null;
            readonly forecastBillableTaskAndAllocationsCombinedSoft: number | null;
            readonly forecastNonBillableTaskAndAllocationsCombinedSoft: number | null;
            readonly forecastTotalTimeTaskAndAllocationsCombinedSoft: number | null;
            readonly forecastBillableUtilizationTaskAndAllocationsCombinedSoft: number | null;
            readonly forecastNonBillableUtilizationTaskAndAllocationsCombinedSoft: number | null;
            readonly forecastResourceUtilizationTaskAndAllocationsCombinedSoft: number | null;
            readonly forecastBillableTaskAndAllocationsCombinedSoftWin: number | null;
            readonly forecastNonBillableTaskAndAllocationsCombinedSoftWin: number | null;
            readonly forecastTotalTimeTaskAndAllocationsCombinedSoftWin: number | null;
            readonly forecastBillableUtilizationTaskAndAllocationsCombinedSoftWin: number | null;
            readonly forecastNonBillableUtilizationTaskAndAllocationsCombinedSoftWin: number | null;
            readonly forecastResourceUtilizationTaskAndAllocationsCombinedSoftWin: number | null;
            readonly forecastBillableTaskAndAllocationsCombinedHard: number | null;
            readonly forecastNonBillableTaskAndAllocationsCombinedHard: number | null;
            readonly forecastTotalTimeTaskAndAllocationsCombinedHard: number | null;
            readonly forecastBillableUtilizationTaskAndAllocationsCombinedHard: number | null;
            readonly forecastNonBillableUtilizationTaskAndAllocationsCombinedHard: number | null;
            readonly forecastResourceUtilizationTaskAndAllocationsCombinedHard: number | null;
            readonly billableActualVsPlan: number | null;
            readonly billableActualVsPlanWin: number | null;
            readonly billableActualVsPlanSoft: number | null;
            readonly billableActualVsPlanSoftWin: number | null;
            readonly billableActualVsPlanHard: number | null;
            readonly nonBillableActualVsPlan: number | null;
            readonly nonBillableActualVsPlanWin: number | null;
            readonly nonBillableActualVsPlanSoft: number | null;
            readonly nonBillableActualVsPlanSoftWin: number | null;
            readonly nonBillableActualVsPlanHard: number | null;
            readonly internalActualVsPlan: number | null;
            readonly totalActualVsPlan: number | null;
            readonly totalActualVsPlanWin: number | null;
            readonly totalActualVsPlanSoft: number | null;
            readonly totalActualVsPlanSoftWin: number | null;
            readonly totalActualVsPlanHard: number | null;
            readonly remainingBillableProjectMinutes: number | null;
            readonly remainingBillableProjectMinutesWin: number | null;
            readonly remainingBillableProjectMinutesSoft: number | null;
            readonly remainingBillableProjectMinutesSoftWin: number | null;
            readonly remainingBillableProjectMinutesHard: number | null;
            readonly remainingNonBillableProjectMinutes: number | null;
            readonly remainingNonBillableProjectMinutesWin: number | null;
            readonly remainingNonBillableProjectMinutesSoft: number | null;
            readonly remainingNonBillableProjectMinutesSoftWin: number | null;
            readonly remainingNonBillableProjectMinutesHard: number | null;
            readonly remainingInternalMinutes: number | null;
            readonly remainingTotalMinutes: number | null;
            readonly remainingTotalMinutesWin: number | null;
            readonly remainingTotalMinutesSoft: number | null;
            readonly remainingTotalMinutesSoftWin: number | null;
            readonly remainingTotalMinutesHard: number | null;
            readonly remainingOverMinutes: number | null;
            readonly remainingBillableUtilization: number | null;
            readonly remainingBillableUtilizationWin: number | null;
            readonly remainingBillableUtilizationSoft: number | null;
            readonly remainingBillableUtilizationSoftWin: number | null;
            readonly remainingBillableUtilizationHard: number | null;
            readonly remainingNonBillableUtilization: number | null;
            readonly remainingNonBillableUtilizationWin: number | null;
            readonly remainingNonBillableUtilizationSoft: number | null;
            readonly remainingNonBillableUtilizationSoftWin: number | null;
            readonly remainingNonBillableUtilizationHard: number | null;
            readonly remainingInternalUtilization: number | null;
            readonly remainingResourceUtilization: number | null;
            readonly remainingResourceUtilizationWin: number | null;
            readonly remainingResourceUtilizationSoft: number | null;
            readonly remainingResourceUtilizationSoftWin: number | null;
            readonly remainingResourceUtilizationHard: number | null;
            readonly remainingBillableTaskAndAllocationsCombined: number | null;
            readonly remainingNonBillableTaskAndAllocationsCombined: number | null;
            readonly remainingInternalTimeTaskAndAllocationsCombined: number | null;
            readonly remainingTotalTimeTaskAndAllocationsCombined: number | null;
            readonly remainingBillableUtilizationTaskAndAllocationsCombined: number | null;
            readonly remainingInternalUtilizationTaskAndAllocationsCombined: number | null;
            readonly remainingResourceUtilizationTaskAndAllocationsCombined: number | null;
            readonly forecastBillableProjectMinutes: number | null;
            readonly forecastBillableProjectMinutesWin: number | null;
            readonly forecastBillableProjectMinutesSoft: number | null;
            readonly forecastBillableProjectMinutesSoftWin: number | null;
            readonly forecastBillableProjectMinutesHard: number | null;
            readonly forecastNonBillableProjectMinutes: number | null;
            readonly forecastNonBillableProjectMinutesWin: number | null;
            readonly forecastNonBillableProjectMinutesSoft: number | null;
            readonly forecastNonBillableProjectMinutesSoftWin: number | null;
            readonly forecastNonBillableProjectMinutesHard: number | null;
            readonly forecastInternalMinutes: number | null;
            readonly forecastTotalMinutes: number | null;
            readonly forecastTotalMinutesWin: number | null;
            readonly forecastTotalMinutesSoft: number | null;
            readonly forecastTotalMinutesSoftWin: number | null;
            readonly forecastTotalMinutesHard: number | null;
            readonly forecastOverMinutes: number | null;
            readonly forecastOverMinutesWin: number | null;
            readonly forecastOverMinutesSoft: number | null;
            readonly forecastOverMinutesSoftWin: number | null;
            readonly forecastOverMinutesHard: number | null;
            readonly forecastBillableUtilization: number | null;
            readonly forecastBillableUtilizationWin: number | null;
            readonly forecastBillableUtilizationSoft: number | null;
            readonly forecastBillableUtilizationSoftWin: number | null;
            readonly forecastBillableUtilizationHard: number | null;
            readonly forecastNonBillableUtilization: number | null;
            readonly forecastNonBillableUtilizationWin: number | null;
            readonly forecastNonBillableUtilizationSoft: number | null;
            readonly forecastNonBillableUtilizationSoftWin: number | null;
            readonly forecastNonBillableUtilizationHard: number | null;
            readonly forecastInternalUtilization: number | null;
            readonly forecastResourceUtilization: number | null;
            readonly forecastResourceUtilizationWin: number | null;
            readonly forecastResourceUtilizationSoft: number | null;
            readonly forecastResourceUtilizationSoftWin: number | null;
            readonly forecastResourceUtilizationHard: number | null;
            readonly forecastBillableTaskAndAllocationsCombined: number | null;
            readonly forecastNonBillableTaskAndAllocationsCombined: number | null;
            readonly forecastInternalTimeTaskAndAllocationsCombined: number | null;
            readonly forecastTotalTimeTaskAndAllocationsCombined: number | null;
            readonly forecastBillableUtilizationTaskAndAllocationsCombined: number | null;
            readonly forecastNonBillableUtilizationTaskAndAllocationsCombined: number | null;
            readonly forecastInternalUtilizationTaskAndAllocationsCombined: number | null;
            readonly forecastResourceUtilizationTaskAndAllocationsCombined: number | null;
            readonly tasksEstimateBillableMinutes: number | null;
            readonly tasksEstimateNonBillableMinutes: number | null;
            readonly tasksEstimateTotalMinutes: number | null;
            readonly tasksBillableUtilization: number | null;
            readonly tasksNonBillableUtilization: number | null;
            readonly tasksResourceUtilization: number | null;
            readonly tasksOverMinutes: number | null;
            readonly tasksRemainingBillableMinutes: number | null;
            readonly tasksRemainingNonBillableMinutes: number | null;
            readonly tasksRemainingTotalMinutes: number | null;
            readonly tasksRemainingOverMinutes: number | null;
            readonly tasksRemainingBillableUtilization: number | null;
            readonly tasksRemainingNonBillableUtilization: number | null;
            readonly tasksRemainingResourceUtilization: number | null;
            readonly tasksOverdueRemainingBillableMinutes: number | null;
            readonly tasksOverdueRemainingNonBillableMinutes: number | null;
            readonly tasksOverdueRemainingTotalMinutes: number | null;
            readonly tasksForecastBillableMinutes: number | null;
            readonly tasksForecastNonBillableMinutes: number | null;
            readonly tasksForecastTotalMinutes: number | null;
            readonly tasksForecastOverMinutes: number | null;
            readonly tasksForecastBillableUtilization: number | null;
            readonly tasksForecastNonBillableUtilization: number | null;
            readonly tasksForecastResourceUtilization: number | null;
            readonly tasksBillableActualVsPlan: number | null;
            readonly tasksNonBillableActualVsPlan: number | null;
            readonly tasksTotalActualVsPlan: number | null;
            readonly plannedBillableAllocationVsTask: number | null;
            readonly plannedBillableAllocationVsTaskWin: number | null;
            readonly plannedBillableAllocationVsTaskSoft: number | null;
            readonly plannedBillableAllocationVsTaskSoftWin: number | null;
            readonly plannedBillableAllocationVsTaskHard: number | null;
            readonly plannedNonBillableAllocationVsTask: number | null;
            readonly plannedNonBillableAllocationVsTaskWin: number | null;
            readonly plannedNonBillableAllocationVsTaskSoft: number | null;
            readonly plannedNonBillableAllocationVsTaskSoftWin: number | null;
            readonly plannedNonBillableAllocationVsTaskHard: number | null;
            readonly plannedAllocationVsTask: number | null;
            readonly plannedAllocationVsTaskWin: number | null;
            readonly plannedAllocationVsTaskSoft: number | null;
            readonly plannedAllocationVsTaskSoftWin: number | null;
            readonly plannedAllocationVsTaskHard: number | null;
            readonly remainingBillableAllocationVsTask: number | null;
            readonly remainingBillableAllocationVsTaskWin: number | null;
            readonly remainingBillableAllocationVsTaskSoft: number | null;
            readonly remainingBillableAllocationVsTaskSoftWin: number | null;
            readonly remainingBillableAllocationVsTaskHard: number | null;
            readonly remainingNonBillableAllocationVsTask: number | null;
            readonly remainingNonBillableAllocationVsTaskWin: number | null;
            readonly remainingNonBillableAllocationVsTaskSoft: number | null;
            readonly remainingNonBillableAllocationVsTaskSoftWin: number | null;
            readonly remainingNonBillableAllocationVsTaskHard: number | null;
            readonly remainingAllocationVsTask: number | null;
            readonly remainingAllocationVsTaskWin: number | null;
            readonly remainingAllocationVsTaskSoft: number | null;
            readonly remainingAllocationVsTaskSoftWin: number | null;
            readonly remainingAllocationVsTaskHard: number | null;
            readonly workingMinutes: number | null;
            readonly timeOffMinutes: number | null;
            readonly availableMinutes: number | null;
            readonly performance: number | null;
          } | null;
        } | null;
      } | null> | null;
    } | null;
  } | null;
  readonly " $fragmentType": "UtilizationReportPeriodRoleLoader_viewer";
};
export type UtilizationReportPeriodRoleLoader_viewer$key = {
  readonly " $data"?: UtilizationReportPeriodRoleLoader_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"UtilizationReportPeriodRoleLoader_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "endDay"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "endMonth"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "endYear"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "pageSize"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "searchQuery"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "startDay"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "startMonth"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "startYear"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "UtilizationReportPeriodRoleLoader_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "endDay",
              "variableName": "endDay"
            },
            {
              "kind": "Variable",
              "name": "endMonth",
              "variableName": "endMonth"
            },
            {
              "kind": "Variable",
              "name": "endYear",
              "variableName": "endYear"
            },
            {
              "kind": "Variable",
              "name": "first",
              "variableName": "pageSize"
            },
            {
              "kind": "Variable",
              "name": "searchQuery",
              "variableName": "searchQuery"
            },
            {
              "kind": "Variable",
              "name": "startDay",
              "variableName": "startDay"
            },
            {
              "kind": "Variable",
              "name": "startMonth",
              "variableName": "startMonth"
            },
            {
              "kind": "Variable",
              "name": "startYear",
              "variableName": "startYear"
            }
          ],
          "concreteType": "RoleTypeConnection",
          "kind": "LinkedField",
          "name": "resourceBasedRoles",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RoleTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Role",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ResourceNumbers",
                      "kind": "LinkedField",
                      "name": "resourceNumbers",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "actualBillableProjectMinutes",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "actualNonBillableProjectMinutes",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "actualInternalMinutes",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "actualTotalMinutes",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "actualOverMinutes",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "actualDoneTaskMinutes",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "actualBillableUtilization",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "actualNonBillableUtilization",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "actualInternalUtilization",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "actualResourceUtilization",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedBillableProjectMinutes",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedBillableProjectMinutesWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedBillableProjectMinutesSoft",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedBillableProjectMinutesSoftWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedBillableProjectMinutesHard",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedNonBillableProjectMinutes",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedNonBillableProjectMinutesWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedNonBillableProjectMinutesSoft",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedNonBillableProjectMinutesSoftWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedNonBillableProjectMinutesHard",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedInternalMinutes",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedTotalMinutes",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedTotalMinutesWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedTotalMinutesSoft",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedTotalMinutesSoftWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedTotalMinutesHard",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedOverMinutes",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedOverMinutesWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedOverMinutesSoft",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedOverMinutesSoftWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedOverMinutesHard",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedDoneTaskMinutes",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedBillableUtilization",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedBillableUtilizationWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedBillableUtilizationSoft",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedBillableUtilizationSoftWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedBillableUtilizationHard",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedNonBillableUtilization",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedNonBillableUtilizationWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedNonBillableUtilizationSoft",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedNonBillableUtilizationSoftWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedNonBillableUtilizationHard",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedInternalUtilization",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedResourceUtilization",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedResourceUtilizationWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedResourceUtilizationSoft",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedResourceUtilizationSoftWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedResourceUtilizationHard",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedBillableTaskAndAllocationsCombined",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedNonBillableTaskAndAllocationsCombined",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedInternalTimeTaskAndAllocationsCombined",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedTotalTimeTaskAndAllocationsCombined",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedBillableUtilizationTaskAndAllocationsCombined",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedNonBillableUtilizationTaskAndAllocationsCombined",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedInternalUtilizationTaskAndAllocationsCombined",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedResourceUtilizationTaskAndAllocationsCombined",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedBillableTaskAndAllocationsCombinedWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedNonBillableTaskAndAllocationsCombinedWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedTotalTimeTaskAndAllocationsCombinedWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedBillableUtilizationTaskAndAllocationsCombinedWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedNonBillableUtilizationTaskAndAllocationsCombinedWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedResourceUtilizationTaskAndAllocationsCombinedWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedBillableTaskAndAllocationsCombinedSoft",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedNonBillableTaskAndAllocationsCombinedSoft",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedTotalTimeTaskAndAllocationsCombinedSoft",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedBillableUtilizationTaskAndAllocationsCombinedSoft",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedNonBillableUtilizationTaskAndAllocationsCombinedSoft",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedResourceUtilizationTaskAndAllocationsCombinedSoft",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedBillableTaskAndAllocationsCombinedSoftWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedNonBillableTaskAndAllocationsCombinedSoftWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedTotalTimeTaskAndAllocationsCombinedSoftWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedBillableUtilizationTaskAndAllocationsCombinedSoftWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedNonBillableUtilizationTaskAndAllocationsCombinedSoftWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedResourceUtilizationTaskAndAllocationsCombinedSoftWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedBillableTaskAndAllocationsCombinedHard",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedNonBillableTaskAndAllocationsCombinedHard",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedTotalTimeTaskAndAllocationsCombinedHard",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedBillableUtilizationTaskAndAllocationsCombinedHard",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedNonBillableUtilizationTaskAndAllocationsCombinedHard",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedResourceUtilizationTaskAndAllocationsCombinedHard",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingBillableTaskAndAllocationsCombinedWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingNonBillableTaskAndAllocationsCombinedWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingTotalTimeTaskAndAllocationsCombinedWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingBillableUtilizationTaskAndAllocationsCombinedWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingNonBillableUtilizationTaskAndAllocationsCombinedWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingResourceUtilizationTaskAndAllocationsCombinedWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingBillableTaskAndAllocationsCombinedSoft",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingNonBillableTaskAndAllocationsCombinedSoft",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingTotalTimeTaskAndAllocationsCombinedSoft",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingBillableUtilizationTaskAndAllocationsCombinedSoft",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingNonBillableUtilizationTaskAndAllocationsCombinedSoft",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingResourceUtilizationTaskAndAllocationsCombinedSoft",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingBillableTaskAndAllocationsCombinedSoftWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingNonBillableTaskAndAllocationsCombinedSoftWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingTotalTimeTaskAndAllocationsCombinedSoftWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingBillableUtilizationTaskAndAllocationsCombinedSoftWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingNonBillableUtilizationTaskAndAllocationsCombinedSoftWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingResourceUtilizationTaskAndAllocationsCombinedSoftWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingBillableTaskAndAllocationsCombinedHard",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingNonBillableTaskAndAllocationsCombinedHard",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingTotalTimeTaskAndAllocationsCombinedHard",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingBillableUtilizationTaskAndAllocationsCombinedHard",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingNonBillableUtilizationTaskAndAllocationsCombinedHard",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingResourceUtilizationTaskAndAllocationsCombinedHard",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastBillableTaskAndAllocationsCombinedWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastNonBillableTaskAndAllocationsCombinedWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastTotalTimeTaskAndAllocationsCombinedWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastBillableUtilizationTaskAndAllocationsCombinedWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastNonBillableUtilizationTaskAndAllocationsCombinedWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastResourceUtilizationTaskAndAllocationsCombinedWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastBillableTaskAndAllocationsCombinedSoft",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastNonBillableTaskAndAllocationsCombinedSoft",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastTotalTimeTaskAndAllocationsCombinedSoft",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastBillableUtilizationTaskAndAllocationsCombinedSoft",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastNonBillableUtilizationTaskAndAllocationsCombinedSoft",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastResourceUtilizationTaskAndAllocationsCombinedSoft",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastBillableTaskAndAllocationsCombinedSoftWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastNonBillableTaskAndAllocationsCombinedSoftWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastTotalTimeTaskAndAllocationsCombinedSoftWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastBillableUtilizationTaskAndAllocationsCombinedSoftWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastNonBillableUtilizationTaskAndAllocationsCombinedSoftWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastResourceUtilizationTaskAndAllocationsCombinedSoftWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastBillableTaskAndAllocationsCombinedHard",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastNonBillableTaskAndAllocationsCombinedHard",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastTotalTimeTaskAndAllocationsCombinedHard",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastBillableUtilizationTaskAndAllocationsCombinedHard",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastNonBillableUtilizationTaskAndAllocationsCombinedHard",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastResourceUtilizationTaskAndAllocationsCombinedHard",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "billableActualVsPlan",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "billableActualVsPlanWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "billableActualVsPlanSoft",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "billableActualVsPlanSoftWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "billableActualVsPlanHard",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "nonBillableActualVsPlan",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "nonBillableActualVsPlanWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "nonBillableActualVsPlanSoft",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "nonBillableActualVsPlanSoftWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "nonBillableActualVsPlanHard",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "internalActualVsPlan",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "totalActualVsPlan",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "totalActualVsPlanWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "totalActualVsPlanSoft",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "totalActualVsPlanSoftWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "totalActualVsPlanHard",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingBillableProjectMinutes",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingBillableProjectMinutesWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingBillableProjectMinutesSoft",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingBillableProjectMinutesSoftWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingBillableProjectMinutesHard",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingNonBillableProjectMinutes",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingNonBillableProjectMinutesWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingNonBillableProjectMinutesSoft",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingNonBillableProjectMinutesSoftWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingNonBillableProjectMinutesHard",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingInternalMinutes",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingTotalMinutes",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingTotalMinutesWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingTotalMinutesSoft",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingTotalMinutesSoftWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingTotalMinutesHard",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingOverMinutes",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingBillableUtilization",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingBillableUtilizationWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingBillableUtilizationSoft",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingBillableUtilizationSoftWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingBillableUtilizationHard",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingNonBillableUtilization",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingNonBillableUtilizationWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingNonBillableUtilizationSoft",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingNonBillableUtilizationSoftWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingNonBillableUtilizationHard",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingInternalUtilization",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingResourceUtilization",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingResourceUtilizationWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingResourceUtilizationSoft",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingResourceUtilizationSoftWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingResourceUtilizationHard",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingBillableTaskAndAllocationsCombined",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingNonBillableTaskAndAllocationsCombined",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingInternalTimeTaskAndAllocationsCombined",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingTotalTimeTaskAndAllocationsCombined",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingBillableUtilizationTaskAndAllocationsCombined",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingInternalUtilizationTaskAndAllocationsCombined",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingResourceUtilizationTaskAndAllocationsCombined",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastBillableProjectMinutes",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastBillableProjectMinutesWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastBillableProjectMinutesSoft",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastBillableProjectMinutesSoftWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastBillableProjectMinutesHard",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastNonBillableProjectMinutes",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastNonBillableProjectMinutesWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastNonBillableProjectMinutesSoft",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastNonBillableProjectMinutesSoftWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastNonBillableProjectMinutesHard",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastInternalMinutes",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastTotalMinutes",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastTotalMinutesWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastTotalMinutesSoft",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastTotalMinutesSoftWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastTotalMinutesHard",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastOverMinutes",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastOverMinutesWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastOverMinutesSoft",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastOverMinutesSoftWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastOverMinutesHard",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastBillableUtilization",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastBillableUtilizationWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastBillableUtilizationSoft",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastBillableUtilizationSoftWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastBillableUtilizationHard",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastNonBillableUtilization",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastNonBillableUtilizationWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastNonBillableUtilizationSoft",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastNonBillableUtilizationSoftWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastNonBillableUtilizationHard",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastInternalUtilization",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastResourceUtilization",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastResourceUtilizationWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastResourceUtilizationSoft",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastResourceUtilizationSoftWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastResourceUtilizationHard",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastBillableTaskAndAllocationsCombined",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastNonBillableTaskAndAllocationsCombined",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastInternalTimeTaskAndAllocationsCombined",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastTotalTimeTaskAndAllocationsCombined",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastBillableUtilizationTaskAndAllocationsCombined",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastNonBillableUtilizationTaskAndAllocationsCombined",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastInternalUtilizationTaskAndAllocationsCombined",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "forecastResourceUtilizationTaskAndAllocationsCombined",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "tasksEstimateBillableMinutes",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "tasksEstimateNonBillableMinutes",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "tasksEstimateTotalMinutes",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "tasksBillableUtilization",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "tasksNonBillableUtilization",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "tasksResourceUtilization",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "tasksOverMinutes",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "tasksRemainingBillableMinutes",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "tasksRemainingNonBillableMinutes",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "tasksRemainingTotalMinutes",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "tasksRemainingOverMinutes",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "tasksRemainingBillableUtilization",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "tasksRemainingNonBillableUtilization",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "tasksRemainingResourceUtilization",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "tasksOverdueRemainingBillableMinutes",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "tasksOverdueRemainingNonBillableMinutes",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "tasksOverdueRemainingTotalMinutes",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "tasksForecastBillableMinutes",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "tasksForecastNonBillableMinutes",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "tasksForecastTotalMinutes",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "tasksForecastOverMinutes",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "tasksForecastBillableUtilization",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "tasksForecastNonBillableUtilization",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "tasksForecastResourceUtilization",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "tasksBillableActualVsPlan",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "tasksNonBillableActualVsPlan",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "tasksTotalActualVsPlan",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedBillableAllocationVsTask",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedBillableAllocationVsTaskWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedBillableAllocationVsTaskSoft",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedBillableAllocationVsTaskSoftWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedBillableAllocationVsTaskHard",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedNonBillableAllocationVsTask",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedNonBillableAllocationVsTaskWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedNonBillableAllocationVsTaskSoft",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedNonBillableAllocationVsTaskSoftWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedNonBillableAllocationVsTaskHard",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedAllocationVsTask",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedAllocationVsTaskWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedAllocationVsTaskSoft",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedAllocationVsTaskSoftWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plannedAllocationVsTaskHard",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingBillableAllocationVsTask",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingBillableAllocationVsTaskWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingBillableAllocationVsTaskSoft",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingBillableAllocationVsTaskSoftWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingBillableAllocationVsTaskHard",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingNonBillableAllocationVsTask",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingNonBillableAllocationVsTaskWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingNonBillableAllocationVsTaskSoft",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingNonBillableAllocationVsTaskSoftWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingNonBillableAllocationVsTaskHard",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingAllocationVsTask",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingAllocationVsTaskWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingAllocationVsTaskSoft",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingAllocationVsTaskSoftWin",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "remainingAllocationVsTaskHard",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "workingMinutes",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "timeOffMinutes",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "availableMinutes",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "performance",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "9c3fed51244e7fd98be67da1af8f8502";

export default node;
